export default __webpack_public_path__ + "static/media/territory_management.55ada7c4.png";